<template>
	<div>
		<el-card>
			<el-form :inline="true" ref="selectForm" :model="formInline" class="demo-form-inline" style="" size="mini">
				<el-form-item label="门店名称">
					<el-input v-model="formInline.store_name" placeholder="可模糊搜索" clearable></el-input>
				</el-form-item>
				<el-form-item label="客户姓名">
					<el-input v-model="formInline.user_name" placeholder="可模糊搜索" clearable></el-input>
				</el-form-item>
				<el-form-item label="客户电话">
					<el-input v-model="formInline.user_tel" placeholder="可模糊搜索" clearable></el-input>
				</el-form-item>
				<el-form-item label="扣款状态">
					<el-select v-model="formInline.payment_state" clearable placeholder="请选择" size="mini" >
						<el-option label="全部" value="-1"></el-option>
						<el-option label="申请中" value="0"></el-option>
						<el-option label="撤销" value="1"></el-option>
						<el-option label="失败" value="2"></el-option>
						<el-option label="逾期" value="3"></el-option>
						<el-option label="成功" value="4"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="getData()">查询</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<el-card style="margin-top: 10px;">
			<el-table :data="data.freezes"  style="width: 100%;text-align: center;" size="mini">
				<el-table-column align="center" header-align="center" label="编号" width="100">
					<template slot-scope="scope">
						{{scope.$index + 1}}
					</template>
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="store_name" label="门店名称">
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="user_name" label="客户姓名">
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="user_tel" label="客户电话">
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="freeze_amount" label="授权金额">
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="employe_name" label="店员姓名">
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="amount_balance" label="余额">
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="total_pay_amount" label="扣款金额">
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="" label="当前阶段">
					<template slot-scope="scope">
						<span v-if="scope.row.freeze_state==0 || scope.row.freeze_state==1">租车押金</span>
						<span v-if="scope.row.freeze_state==2">违章押金</span>
						<span v-if="scope.row.freeze_state==3">已结算</span>
						<!-- <el-button size="mini" type="danger" @click="deleteStore(scope.$index, scope.row)">取消认证</el-button> -->
					</template>
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="" label="授权时间">
					<template slot-scope="scope">
						{{timeFormat(scope.row.freeze_date,'yyyy-mm-dd hh:MM:ss')}}
						<!-- <el-button size="mini" type="danger" @click="deleteStore(scope.$index, scope.row)">取消认证</el-button> -->
					</template>
				</el-table-column>
				
				<el-table-column align="center" header-align="center" label="查看" width="150">
					<template slot-scope="scope">
						<el-button type="primary" size="mini" @click="toFreezeInfo(scope.$index, scope.row)">查看</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div style="display: flex;justify-content: flex-end; ">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="formInline.page"
				 :page-sizes="[10, 20, 50, 100]" :page-size="formInline.limit" layout="total, sizes, prev, pager, next, jumper"
				 :total="data.total">
				</el-pagination>
			</div>
		</el-card>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				freeze_state:'',
				formInline: {
					page: 1,
					limit: 10,
					freeze_state: [0,1,2,],
					store_name: '',
					payment_state: '-1',
					user_name: '',
					user_tel: ''
				},
				data: []
			}
		},

		mounted() {

			this.getData();
		},
		methods: {
			changeSelection(e) {
				this.formInline.freeze_state=[e];
				console.log(this.freeze_state);
				console.log(this.formInline.freeze_state);
			},
			handleSizeChange(e) {
				this.formInline.limit = e;
				this.getData();
			},
			handleCurrentChange(e) {
				this.formInline.page = e;
				this.getData();
			},
			toFreezeInfo(index,row){
				this.$router.push({path:'/freezeInfo',query:{freeze_id:row.freeze_id}});
			},
			getData() {
				var that = this;
				this.$axios.post('zuche/store/getFreezeList', this.formInline).then(function(res) {
					console.log(res);
					if (res.data.success) {
						that.data = res.data.result;
					} else {
						that.$message.error(res.data.message);
					}
				});
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/freezeing.vue